import type { GetStaticProps } from 'next'
import type { FC, ReactNode } from 'react'
import type { VehicleSelection, VehicleSummary } from '@/types'

import { useCallback, useMemo, useState } from 'react'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { scrollToSection } from '@/lib/scroll'
import { getPublishedVehicles } from '@/lib/vehicles'
import { toBookingVehicle } from '@/lib/vehicle-helpers'
import { loadWithBuildFallback } from '@/lib/static-props'
import FleetSection from '@/components/vehicles/fleet-section'
import BookingSection from '@/components/booking/booking-section'

interface HomeProps {
    vehicles: Array<VehicleSummary>
}

export const getStaticProps: GetStaticProps<HomeProps> = async () => {
    const vehicles = await loadWithBuildFallback('inicio', getPublishedVehicles, [])

    return {
        props: { vehicles },
        revalidate: 60
    }
}

const Home: FC<HomeProps> = ({ vehicles }): ReactNode => {
    const [selection, setSelection] = useState<VehicleSelection | null>(null)
    const bookingVehicles = useMemo(() => vehicles.map(toBookingVehicle), [vehicles])
    const ogImage = vehicles.find(vehicle => vehicle.imagen)?.imagen ?? undefined

    const handleReserve = useCallback((vehicle: VehicleSummary) => {
        setSelection(current => ({ vehicleId: vehicle.id, key: (current?.key ?? 0) + 1 }))
        scrollToSection('reservar')
    }, [])

    return (
        <Layout>
            <Seo ogImage={ogImage} />

            <FleetSection vehicles={vehicles} onReserve={handleReserve} />

            <BookingSection vehicles={bookingVehicles} selection={selection} />
        </Layout>
    )
}

export default Home
